import type { CoreFetch } from '~/types/CoreFetch'
import type { WalletApiResponse } from '~/types/WalletApiResponse'

export function provideFetchWallet(coreFetch: CoreFetch) {
  return () => coreFetch.$get<WalletApiResponse>('/wallet/wallet/self/')
}
